exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#import-data-page-container{width:100%;padding:20px;background-color:#fff}#import-data-page-container .icon{font-size:72px;line-height:72px;margin-bottom:24px;color:#52c41a}#import-data-page-container .import-complete-label{font-size:24px;color:#4f4f4f;font-weight:500;line-height:32px;margin-bottom:16px}#import-data-page-container .import-data-page-content{margin-bottom:50px}#import-data-page-container .import-data-page-content .table-container{width:100%}#import-data-page-container .import-data-page-content .table-container td{text-align:center}#import-data-page-container .import-data-page-content .file-selector-container,#import-data-page-container .import-data-page-content .table-container .ant-select{width:100%}#import-data-page-container .import-data-page-content .first-line-preview{padding-right:10px}#import-data-page-container .import-data-page-content .row{padding-top:5px;padding-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/settings/importData.scss
// module id = 2180
// module chunks = 43